import { create } from 'zustand';

export interface TrackedAPPostingWorkflow {
  workflowId: string;
  apPostingId: string;
  invoiceNum: string;
  action: 'approve' | 'discard' | 'correct';
}

interface APPostingWorkflowStore {
  workflows: TrackedAPPostingWorkflow[];
  trackWorkflow: (workflow: TrackedAPPostingWorkflow) => void;
  removeWorkflow: (workflowId: string) => void;
}

export const useAPPostingWorkflowStore = create<APPostingWorkflowStore>((set) => ({
  workflows: [],
  trackWorkflow: (workflow) =>
    set((state) => {
      const existing = state.workflows.find((item) => item.workflowId === workflow.workflowId);
      if (existing) {
        return {
          workflows: state.workflows.map((item) =>
            item.workflowId === workflow.workflowId ? workflow : item
          ),
        };
      }

      return {
        workflows: [...state.workflows, workflow],
      };
    }),
  removeWorkflow: (workflowId) =>
    set((state) => ({
      workflows: state.workflows.filter((workflow) => workflow.workflowId !== workflowId),
    })),
}));
